import React from 'react';
import Container from 'react-bootstrap/Container';
import "./index.css";

function ContactBanner() {
    return (
        <Container fluid className="contact-banner">
            <h1 className="contact-banner-text">Contact</h1>
        </Container>
    );
}

export default ContactBanner;